export const CURRENCY = {
    GBP: '£',
};

export type CurrencyType = keyof typeof CURRENCY;
